import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { BUTTON_TYPE, DIVIDER_SIZE, PANELS } from '@helpers/constants'
import { AppContext } from '@state/context'
import Button from '@components/Button'
import { openPanel } from '@state/actions/panelsActions'
import Divider from '@components/Divider'

const ContentHeader = (props) => {
  const {
    hideButtons = false
  } = props
  const [, dispatch] = useContext(AppContext)

  return (
    <>
      <div>
        <div className={'flex justify-end min-h-[66px] py-4'}>
          {!hideButtons && (
            <>
              <Button
                type={BUTTON_TYPE.SECONDARY}
                handleClick={() => {
                  dispatch(openPanel(PANELS.VIEW_SUBJECT_AREA))
                }}
                marginRight
              >
                Koppling till läroplanen
              </Button>
              <Button
                type={BUTTON_TYPE.SECONDARY}
                handleClick={() => {
                  dispatch(openPanel(PANELS.TEACHERS_GUIDE))
                }}
                marginLeft
              >
                Lärarhandledning
              </Button>
            </>
          )}
        </div>
      </div>

      <Divider size={DIVIDER_SIZE.LINE} line />
      <Divider size={DIVIDER_SIZE.SMALL} />
    </>
  )
}

ContentHeader.propTypes = {
  hideButtons: PropTypes.bool,
}

export default ContentHeader
